class GraphicComp {
	constructor() {
		this._layers = [];
		
	}
}